/* eslint-disable max-len */
import * as actionTypes from "../actions/actionTypes/newTimesheetActionTypes";
import * as modelActionTypes from "../actions/actionTypes/newTimesheetModelActionTypes";
import { clearAlert, createAlertPayload, flattenEmployees } from "../transformers/timesheetsApprovalTransformer";
import { timesheetTransformerEmployeeTimesheetStatus } from "../transformers/timesheetTransformer";
import initialState from "../newTimesheetInitialState";

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_NEW_TIMESHEET_REQUEST:
      return { ...state, timesheets: [], errors: [] };
    case actionTypes.GET_NEW_TIMESHEET_SUCCESS:
      return { ...state, timesheets: [...state.timesheets, action.payload] };
    case actionTypes.GET_NEW_TIMESHEET_FAILURE:
      return {
        ...state, timesheets: [], filters: { ...initialState.filters }, errors: [...state.errors, "timesheet_list"], loading: false,
      };
    case actionTypes.GET_EMPLOYEE_LIST_REQUEST:
      return { ...state, employees: [] };
    case actionTypes.GET_EMPLOYEE_LIST_SUCCESS:
      return { ...state, employees: [...state.employees, action.payload], flatEmployees: flattenEmployees([...state.employees, action.payload]) };
    case actionTypes.GET_EMPLOYEE_LIST_FAILURE:
      return {
        ...state, employees: [], errors: [...state.errors, "employee_list"], loading: false,
      };
    case actionTypes.GET_LOCATION_LIST_REQUEST:
      return { ...state, locations: [] };
    case actionTypes.GET_LOCATION_LIST_SUCCESS:
      return { ...state, locations: action.payload };
    case actionTypes.GET_LOCATION_LIST_FAILURE:
      return {
        ...state, locations: [], errors: [...state.errors, "location_list"], loading: false,
      };
    // Timesheet Approval
    case actionTypes.APPROVE_EMPLOYEE_TIMESHEETS_REQUEST:
      return { ...state };
    case actionTypes.APPROVE_EMPLOYEE_TIMESHEETS_SUCCESS:
      return { ...state };
    case actionTypes.APPROVE_EMPLOYEE_TIMESHEETS_FAILURE:
      return { ...state, errors: [...state.errors, "approve_timesheet"] };
    // Update the timesheet data after approval request.
    // This is used for generating data when filter is applied so needs to be updated after each approval.
    case modelActionTypes.UPDATE_EMPLOYEE_TIMESHEET_STATUS:
      return {
        ...state,
        timesheets: [
          ...timesheetTransformerEmployeeTimesheetStatus(
            state.timesheets,
            action.payload.userId,
            action.payload.timesheetIds,
            action.payload.status,
          ),
        ],
      };
    // Filters
    case actionTypes.SET_LOCATION_FILTER:
      return { ...state, filters: { ...state.filters, location: [action.payload] } };
    case actionTypes.SET_EMPLOYEE_FILTER:
      return { ...state, filters: { ...state.filters, employee: [action.payload] } };
    case actionTypes.SET_WEEK_FILTER:
      return { ...state, filters: { ...state.filters, week: [action.payload] } };
    case actionTypes.SET_MANAGER_FILTER:
      return { ...state, filters: { ...state.filters, manager: [action.payload] } };
    case actionTypes.RESET_FILTERS:
      return { ...state, filters: initialState.filters };
    // Alerts
    case actionTypes.CREATE_TIMESHEET_APPROVAL_ALERT:
      return { ...state, alerts: createAlertPayload(state.alerts, { ...action.payload, employees: state.flatEmployees }) };
    case actionTypes.CREATE_TIMESHEET_ALERT:
      return { ...state, alerts: [...state.alerts, action.payload] };
    case actionTypes.CLEAR_TIMESHEET_ALERT:
      return { ...state, alerts: clearAlert(state.alerts, action.payload) };

      // Invalid approvals
    case actionTypes.CREATE_INVALID_APPROVAL_ERRORS:
      return { ...state, showInvalidApprovals: true, invalidApprovals: [...state.invalidApprovals, ...action.payload.errors] };
    case actionTypes.CLEAR_INVALID_APPROVAL_ERRORS:
      return { ...state, showInvalidApprovals: false, invalidApprovals: [] };
      // Loading
    case actionTypes.SET_LOADING:
      return { ...state, loading: action.loading };
    case actionTypes.ADD_TIMESHEET_REQUESTV2:
      return {
        ...state,
      };
    case actionTypes.ADD_TIMESHEET_SUCCESSV2:
      return {
        ...state,
      };
    case actionTypes.ADD_TIMESHEET_FAILUREV2:
      return {
        ...state,
      };
    case actionTypes.EDIT_TIMESHEET_REQUEST:
      return {
        ...state,
      };
    case actionTypes.EDIT_TIMESHEET_SUCCESS:
      return {
        ...state,
        activeTimesheetId: action.meta.activeTimesheetId,
      };
    case actionTypes.EDIT_TIMESHEET_FAILURE:
      return {
        ...state,
      };
    case actionTypes.SET_ACTIVE_TIMESHEET:
      return { ...state, activeTimesheetId: action.payload };
    case actionTypes.APPROVE_ZERO_HOURS_MODAL:
      return {
        ...state,
        showZeroHoursModal: action.payload,
      };
    default:
      return { ...state };
  }
};
